import {FC} from 'react'
import { useWindowSize } from 'react-use';
import { getStyledAboutCardHolder } from '../../styled-components/AboutSection.styled'
import { MD_SCREEN } from '../../util/screen-size';
import { MobileCardHolder } from './MobileCardHolder.component'
import { PCCardHolder } from './PCCardHolder.component';

export interface AboutSectionCardHolderProps {
    
}

export const AboutSectionCardHolder: FC<AboutSectionCardHolderProps> = (props) => {

    const { width } = useWindowSize();
    const size = width > MD_SCREEN

    const renderContent = () => {
        if(size){
            return <PCCardHolder />
        } else {
            return <MobileCardHolder />
        }
    }

    const StyledHolderWrapper = getStyledAboutCardHolder()

    return(
        <StyledHolderWrapper>
            {renderContent()}
        </StyledHolderWrapper>
    )
}